import { render } from "./layout2.vue?vue&type=template&id=b3c4dbd6&scoped=true"
import script from "./layout2.vue?vue&type=script&lang=js"
export * from "./layout2.vue?vue&type=script&lang=js"

import "./layout2.vue?vue&type=style&index=0&id=b3c4dbd6&lang=scss&scoped=true"
import "./layout2.vue?vue&type=style&index=1&id=b3c4dbd6&lang=scss"
import "./layout2.vue?vue&type=style&index=2&id=b3c4dbd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c4dbd6"]])

export default __exports__